import React, {useState} from "react"

import FieldTimeReported from "../../time-spent"
import {FieldViewSize} from "../../../../../const"

type Props = {
    className?      : string

    value?          : number
    field           : FieldTimeReported

    options         : {
        restrictEmpty?: boolean
    }

    disabled?       : boolean

    onClick         : callback
    onReset         : callback

    children        : any
}


export default function FieldTimeReported_FormValueNoteEmpty(props:Props) {

    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        props.onReset && props.onReset()
    }

    const className = Classes("ui5-field-form-element not-selectable", "size-"+size, props.className, {
        'is-hovered'        : isHovered || props.children
    })

    const valueFormatted = props.field.getDisplayValue(props.value)

    if (isHovered || props.children) {
        const showButtonReset = !props.disabled && !props.options?.restrictEmpty
        return (
            <>
                <div className={className} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <div className="ui5-txt-default txt-truncate">{valueFormatted}</div>
                    {showButtonReset &&
                        <div className="buttons">
                            <div className="btn-reset" onClick={onDeleteClick} />
                        </div>}
                </div>
                {props.children}
            </>
        )
    }

    // not hovered
    return (
        <>
            <div className={Classes(className, "ui5-txt-default")} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <div className="txt-truncate">{valueFormatted}</div>
            </div>
            {props.children}
        </>
    )
}
